export default function Services() {
  const services = [
    {
      icon: 'ri-code-s-slash-line',
      title: 'Sviluppo Software Custom',
      description: 'Progettiamo e realizziamo applicazioni software su misura per le esigenze specifiche della vostra azienda, utilizzando le tecnologie più avanzate e metodologie agile per garantire qualità, scalabilità e performance ottimali in ogni progetto.'
    },
    {
      icon: 'ri-server-line',
      title: 'Sistemi IT Aziendali',
      description: 'Implementiamo infrastrutture IT complete e integrate, dalla gestione dei server alla sicurezza informatica, garantendo continuità operativa, protezione dei dati e ottimizzazione delle risorse tecnologiche per supportare la crescita del vostro business.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Consulenza Tecnologica',
      description: 'Offriamo consulenza strategica per la trasformazione digitale della vostra azienda, analizzando processi esistenti, identificando opportunità di innovazione e guidandovi nella scelta delle soluzioni tecnologiche più adatte ai vostri obiettivi di business.'
    }
  ];

  return (
    <section id="servizi" className="py-32 bg-[#F8F6F3]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-20">
          <p className="text-sm text-gray-500 uppercase tracking-wider mb-4 font-light">
            I NOSTRI SERVIZI
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#2C2C2C] leading-tight">
            COMPETENZE<br />
            TECNOLOGICHE
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#F5F5F5] rounded-2xl p-12 hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-8">
                <i className={`${service.icon} text-5xl text-[#2C2C2C] group-hover:text-[#1A4D4D] transition-colors`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#2C2C2C] mb-6">
                {service.title}
              </h3>
              
              <p className="text-gray-600 font-light leading-relaxed text-base">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* Additional Services */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-smartphone-line text-3xl text-[#1A4D4D]"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-[#2C2C2C] mb-3">Sviluppo App Mobile</h4>
                <p className="text-gray-600 font-light leading-relaxed">
                  Creiamo applicazioni mobile native e cross-platform per iOS e Android, con interfacce intuitive e performance elevate.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-cloud-line text-3xl text-[#1A4D4D]"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-[#2C2C2C] mb-3">Soluzioni Cloud</h4>
                <p className="text-gray-600 font-light leading-relaxed">
                  Migrazione e gestione di infrastrutture cloud, garantendo flessibilità, sicurezza e riduzione dei costi operativi.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-database-2-line text-3xl text-[#1A4D4D]"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-[#2C2C2C] mb-3">Database Management</h4>
                <p className="text-gray-600 font-light leading-relaxed">
                  Progettazione, ottimizzazione e gestione di database relazionali e NoSQL per garantire integrità e velocità dei dati.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-shield-check-line text-3xl text-[#1A4D4D]"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-[#2C2C2C] mb-3">Sicurezza Informatica</h4>
                <p className="text-gray-600 font-light leading-relaxed">
                  Implementazione di sistemi di sicurezza avanzati per proteggere i vostri dati e prevenire minacce informatiche.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
